import Print from '@mui/icons-material/Print';
import { IconButton } from '@mui/material';
import React from 'react';

import { PrintLabelProps } from './PrintLabel.props';
import { IconButtonColor } from '../../../configs/enums';
import { useGetPrintLabel } from '../../../queries/print-label-query';
import { printLabel } from '../../../utils/print-label-utils';
import { Button, ButtonColorProps, ButtonVariantProps } from '../../atoms/Button';

export const PrintLabel: React.FC<PrintLabelProps> = ({ entityId, entityType, buttonLabel }) => {
  const getPrintLabel = useGetPrintLabel(entityId, entityType);

  const onClickPrintLabel = async () => {
    try {
      const labelText = await getPrintLabel.mutateAsync();
      await printLabel(labelText, entityType, entityId);
    } catch (err) {
      // printLabel's own guards handle user-facing alerts for missing data
      // / printer-not-found; this catch is for the websocket/network/
      // permission failures that surface as thrown errors from qz-tray or
      // the BFF fetch. Without it those become unhandled rejections.
      console.error('[PrintLabel] print failed', err);
      alert('Printing failed. Check QZ Tray is running and try again.');
    }
  };

  return buttonLabel ? (
    <Button
      variant={ButtonVariantProps.Secondary}
      color={ButtonColorProps.Primary}
      onClick={onClickPrintLabel}
    >
      {buttonLabel}
    </Button>
  ) : (
    <IconButton
      aria-label="print label"
      color={IconButtonColor.Primary}
      onClick={onClickPrintLabel}
    >
      <Print />
    </IconButton>
  );
};
